import { render, staticRenderFns } from "./Cerfa.vue?vue&type=template&id=7c61a12a"
import script from "./Cerfa.vue?vue&type=script&lang=js"
export * from "./Cerfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports